import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import SelectionInput from '../../common/components/selection-input'
import YesNoInput from '../../common/components/yes-no-input'
import Validation from '../../common/modules/validation/rules'
import Alert from '../../common/components/alert'
import QuoteNumber from '../../common/components/quote-number'
import InputField from '../../common/components/input-field'
import { mapValues, pickBy } from 'lodash'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import yesNoOptions from '../../common/options/yes-no-options'
import { get } from 'lodash'
import { toCurrency, optionsToInts } from '../../common/util'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withFields } from '../../common/modules/fields'
import { withProductData } from '../../common/modules/product-data'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withState } from '../../common/modules/state'
import { withScrollToTop } from '../../common/modules/scroll-to-top'


export const formConfig = state => {
    const fields = state.fields;
    const productData = state.productData;
    const catastropheCoverAmount = fields.buildingSumInsured * (fields.catastrophePercent/100);
    const selectedState = get(fields, 'ownersCorporationAddress.state')

    return {
        rules:{
            buildingSumInsured:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
                Validation.enforce.greaterThanEqual(0, "Must be a positive value"),
                Validation.enforce.lessThanEqual(250000000, "Must be less than $250,000,000")
            ],
            contentsSumInsured:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
                Validation.enforce.greaterThanEqual(0, "Must be a positive value"),
                Validation.enforce.lessThanEqual(250000000, "Must be less than $250,000,000")
            ],
            lotOwnerContentsSumInsured :[
                Validation.enforce.required("Please select a value"),
            ],
            lossOfRentPercent:[
                Validation.enforce.required("Please select a value"),
            ],
            liabilitySumInsured :[
                Validation.enforce.required("Please select a value"),
            ],
            voluntaryWorkersDeath:[
                Validation.enforce.required("Please select a value"),
            ],
            workersCompensationRequired:[
                Validation.enforce.required("Required"),
            ],
            estimatedWages:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a dollar value"),
                Validation.enforce.predicate(value => fields.ownersCorporationAddress.state == "NSW" ? value > 7500 : true, "Workers Compensation Cover only available where wages exceed $7,500")
            ],
            employeesEstimatedWages:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            labourOnlyEstimatedWages:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            labourMaterialsEstimatedWages:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            labourPlantEstimatedWages:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            labourPlantMaterialsEstimatedWages:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            fidelitySumInsured:[
                Validation.enforce.required("Please select a value"),
            ],
            officeBearersSumInsured:[
                Validation.enforce.required("Please select a value"),
            ],
            machineryBreakdownRequired:[
                Validation.enforce.required("Please tell us if you require cover"),
            ],
            machineryBreakdownSumInsured:[
                Validation.enforce.required("Please select a value"),
            ],
            carStackerTurnTable:[
                Validation.enforce.required("Please answer the question"),
            ],
            airConditioningLocation:[
                Validation.enforce.required("Please select a value"),
            ],
            electronicMotors5KW:[
                Validation.enforce.required("Please answer the question"),
            ],
            chillersOrCoolingTowers:[
                Validation.enforce.required("Please answer the question"),
            ],
            twentyYearOldPlus:[
                Validation.enforce.required("Please answer the question"),
            ],
            catastropheRequired:[
                Validation.enforce.required("Please tell us if you require cover"),
            ],
            catastrophePercent:[
                Validation.enforce.required("Please select a value"),
                Validation.enforce.number("Must be a whole number"),
                Validation.enforce.rangeInclusive(15, 30, "Must be between 15% and 30%"),
            ],
            floodRequested:[
                Validation.enforce.required("Please tell us if you require cover"),
            ],
        },
        predicates: {
            workersCompensationRequired: false,
            estimatedWages: selectedState !== "WA" && fields.workersCompensationRequired === true,
            employeesEstimatedWages: selectedState === "WA" && fields.workersCompensationRequired === true,
            labourOnlyEstimatedWages: selectedState === "WA" && fields.workersCompensationRequired === true,
            labourMaterialsEstimatedWages: selectedState === "WA" && fields.workersCompensationRequired === true,
            labourPlantEstimatedWages: selectedState === "WA" && fields.workersCompensationRequired === true,
            labourPlantMaterialsEstimatedWages: selectedState === "WA" && fields.workersCompensationRequired === true,
            machineryBreakdownSumInsured: fields.machineryBreakdownRequired === true,
            carStackerTurnTable: fields.machineryBreakdownRequired === true,
            airConditioningLocation: fields.machineryBreakdownRequired === true,
            electronicMotors5KW: fields.machineryBreakdownRequired === true,
            chillersOrCoolingTowers: fields.machineryBreakdownRequired === true,
            twentyYearOldPlus: fields.machineryBreakdownRequired === true,
            catastrophePercent: fields.catastropheRequired === true,
            catastropheCoverAmount: fields.catastropheRequired === true,
            storageAndEvacuationAmount: fields.catastropheRequired === true,
            temporaryAccommodationAmount: fields.catastropheRequired === true,
            temporaryAccommodationEscalationOfCostsAmount: fields.catastropheRequired === true
        },
        transformOut: data => ({
            ...data,
            voluntaryWorkersRequired: true,
            fidelityRequired: true,
            cyberSumInsured: 50000,
            officeBearersRequired: true,
            lotOwnerContentsRequired: [10000, 20000].indexOf(data.lotOwnerContentsSumInsured) !== -1
        }),
        inferred:{
            lossOfRentAmount: toCurrency(fields.buildingSumInsured * (fields.lossOfRentPercent/100)),
            catastropheCoverAmount: toCurrency(catastropheCoverAmount),
            storageAndEvacuationAmount: toCurrency(catastropheCoverAmount * 0.05),
            temporaryAccommodationAmount: toCurrency(catastropheCoverAmount * 0.15),
            temporaryAccommodationEscalationOfCostsAmount: toCurrency(catastropheCoverAmount * 0.05),
            governmentAuditAmount: toCurrency(25000),
            cyberSumInsured: toCurrency(50000),
            appealExpensesAmount: toCurrency(100000),
            legalDefenceAmount: toCurrency(50000),
            lotOwnersSumInsured: toCurrency(250000),
            voluntaryWorkersDisablement: toCurrency(fields.voluntaryWorkersDeath * 0.01),
            floodCover: "OPTIONAL",  // Hardcoding this, but this field should be coming back from the server. TODO for a future iteration.
        },
        options:{
            liabilitySumInsured: function(){
                var options = productData.productSumsInsured.Liability;
                // NSW, VIC: $20 Million min liability| ACT,SA,QLD,NT: $10 Million min liability| WA,TAS: $5 Million min liability
                switch (selectedState) {
                    case "NSW":
                    case "VIC":
                        return options.filter(option => option.value >= 20000000)
                    case "SA":
                    case "QLD":
                    case "NT":
                    case "ACT":
                        return options.filter(option => option.value >= 10000000)
                    case "TAS":
                    case "WA":
                        return options.filter(option => option.value >= 5000000)
                }
            }(),
            workersCompensationRequired:    yesNoOptions,
            machineryBreakdownRequired:     yesNoOptions,
            carStackerTurnTable:            yesNoOptions,
            electronicMotors5KW:            yesNoOptions,
            chillersOrCoolingTowers:        yesNoOptions,
            twentyYearOldPlus:              yesNoOptions,
            catastropheRequired:            yesNoOptions,
            floodRequested:                 yesNoOptions,
            voluntaryWorkersDeath:          productData.productSumsInsured.VoluntaryWorkers,
            lossOfRentPercent:              optionsToInts( productData.productOptions.LOSS_OF_RENT_PERCENT ),
            fidelitySumInsured:             productData.productSumsInsured.Fidelity,
            officeBearersSumInsured:        productData.productSumsInsured.OfficeBearersLiability,
            machineryBreakdownSumInsured:   productData.productSumsInsured.MachineryBreakdown,
            airConditioningLocation:        productData.productOptions.MB_AIRCON,
            catastrophePercent:             optionsToInts( productData.productOptions.CATASTROPHE_PERCENT ),
            lotOwnerContentsSumInsured: [{ label: 'Not Selected', value: 0 }, { label: '$10,000', value: 10000 }, { label: '$20,000', value: 20000 }],
        },
    }
}


@withSubmission
@withState
@withNavigation
@withProductData
@withValidation
@withFields
@withRouteBlocker
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {


    onBlur(field){
        const formData = this.props.form.getData();
        const fields = this.props.fields;
        const rules = formData.rules;

        // When the buildingSumInsured looses focus, check to see that it is a number value and if it is
        // set the next field (contentsSumInsured) to 1% of buildingSumInsured
        if(field === "buildingSumInsured"){
            // Only continue if the buildingSumInsured field passes the following rules
            if(Validation.doesPass(fields.buildingSumInsured, rules.buildingSumInsured)){
                // Only update contentsSumInsured if its current value is invalid
                if(!Validation.doesPass(fields.contentsSumInsured, rules.contentsSumInsured)){
                    this.props.actions.fields.updateField("contentsSumInsured", Math.round(fields.buildingSumInsured * 0.01));
                }
            }
        }
    }


    save(){
        this.props.actions.submission.save("/step-3", [
            require("./step-1").formConfig,
            require("./step-2").formConfig,
            require("./step-3").formConfig
        ], this.props.fields);
    }
    


    render() {
       const actions = this.props.actions;
       const formData = this.props.form.getData();
       const predicates = formData.predicates;
       const inferred = formData.inferred;


       return (
            <div className="row">

                <StepTitle>Tell Us About Your Coverage</StepTitle>
                <QuoteNumber />

                <SubHeader>Property Cover</SubHeader>
                <InputField   field="buildingSumInsured"                   type="Currency"    inline={ true }        label="How much would you like to insure your building for?" onBlur={ this.onBlur.bind(this) }  help="This is the maximum amount we would pay out for damage to your building or buildings as defined by the Strata Schemes Management Act, Strata titles Act, Community Titles Act or similar legislation applying to where Your building is situated. Read the PDS for more information." />
                <InputField   field="contentsSumInsured"                   type="Currency"    inline={ true }        label="How much would you like to insure the common area contents for?" help="Common Area Contents include shared property such as swimming pool covers, fire extinguishers and garden equipment. Read the PDS for more information." />
                <InputField   field="lossOfRentPercent"                    type="String"      inline={ true }        label="What percentage of your building sum insured would you like to insure for Loss of Rent?"  help="This is the rent you would have lost if Your Lot/Unit or Common Area is made unfit to be occupied for its intended purpose. Read the PDS for more information." />
                <InputField   field="lossOfRentAmount"                     type="Currency"    inline={ true }        label="Loss of Rent/Temporary Accommodation (total payable)"  />
                <InputField   field="lotOwnersSumInsured"                  type="Currency"    inline={ true }        label="Lot Owner's Fixtures and Improvements"  />

                <SubHeader>Optional Extensions</SubHeader>
                <InputField    field="catastropheRequired"                             type="Boolean"                          label="Do you require Catastrophe Insurance?"                                            />
                <InputField    field="catastrophePercent"                              type="Percent"      inline={ true }     label="Percentage of the building sum insured that is insured for catastrophe cover?"    />
                <InputField    field="catastropheCoverAmount"                          type="Currency"     inline={ true }     label="Sum insured for catastrophe cover"                                                />
                <InputField    field="storageAndEvacuationAmount"                      type="Currency"     inline={ true }     label="Sum insured for storage and evacuation"                                           />
                <InputField    field="temporaryAccommodationAmount"                    type="Currency"     inline={ true }     label="Sum insured for loss of rent/temporary accommodation"                             />
                <InputField    field="temporaryAccommodationEscalationOfCostsAmount"   type="Currency"     inline={ true }     label="Sum insured for temporary accommodation escalation of cost"                       />

                <InputField    field="machineryBreakdownRequired"          type="Boolean"                             label="Do you require Machinery Breakdown cover?"                     />
                <InputField    field="machineryBreakdownSumInsured"        type="Currency"     inline={ true }        label="Machinery Breakdown sum insured"                               />
                <InputField    field="carStackerTurnTable"                 type="Boolean"      inline={ true }        label="Is there a car stacker or turntable?"                          />
                <InputField    field="airConditioningLocation"             type="String"       inline={ true }        label="Is air conditioning located centrally or in individual lots?"  />
                <InputField    field="electronicMotors5KW"                 type="Boolean"      inline={ true }        label="Are there any motors in excess of 5Kw?"                        />
                <InputField    field="chillersOrCoolingTowers"             type="Boolean"      inline={ true }        label="Are there any chilling or cooling towers?"                     />
                <InputField    field="twentyYearOldPlus"                   type="Boolean"      inline={ true }        label="Is there machinery older than 20 years old?"                   />
                <InputField    field="lotOwnerContentsSumInsured"          type="Currency"     inline={ true }        label="Do you require Lot owners contents cover?"   help="Each lot would be covered with this sum insured!"      />

                <SubHeader>Liability Cover</SubHeader>
                <InputField   field="liabilitySumInsured"                  type="Currency"    inline={ true }        label="How much liability cover would you like?" />
                
                <SubHeader>Voluntary Workers</SubHeader>
                <InputField   field="voluntaryWorkersDeath"                type="Currency"    inline={ true }        label="Death" />
                <InputField   field="voluntaryWorkersDisablement"          type="Currency"    inline={ true }        label="Total Disablement (per week)"  />

                <SubHeader show={ predicates.workersCompensationRequired }>Workers Compensation</SubHeader>
                <InputField    field="workersCompensationRequired"         type="Boolean"                            label="Do you require Workers Compensation cover"    />
                <InputField    field="estimatedWages"                      type="Currency"    inline={ true }        label="Estimated wages paid"                         />
                <InputField    field="employeesEstimatedWages"             type="Currency"    inline={ true }        label="Employees estimated wages"                    />
                <InputField    field="labourOnlyEstimatedWages"            type="Currency"    inline={ true }        label="Labour only estimated wages"                  />
                <InputField    field="labourMaterialsEstimatedWages"       type="Currency"    inline={ true }        label="Labour and Materials estimated wages"         />
                <InputField    field="labourPlantEstimatedWages"           type="Currency"    inline={ true }        label="Labour and plant estimated wages"             />
                <InputField    field="labourPlantMaterialsEstimatedWages"  type="Currency"    inline={ true }        label="Labour, plant and materials estimated wages"  />

                <SubHeader>Fidelity Guarantee and Cyber</SubHeader>
                <InputField    field="fidelitySumInsured"                  type="String"      inline={ true }        label="Fidelity Guarantee Sum Insured"      help="We will, up to the Sum Insured stated on the Schedule, indemnify You in respect of: fraudulent misappropriation of Your funds committed during the Period of Insurance."/>
                <InputField    field="cyberSumInsured"                     type="Currency"    inline={ true }        label="Cyber Sum Insured"                       help="Cyber cover (Social Engineering Fraud)."/>

                <SubHeader>Office Bearers</SubHeader>
                <InputField    field="officeBearersSumInsured"             type="String"      inline={ true }        label="Office Bearers Sum Insured"           />

                <SubHeader>Government Audit Costs and Legal Expenses</SubHeader>
                <InputField    field="governmentAuditAmount"                           type="Currency"   inline={ true }       label="Government Audit Costs"                                                           />
                <InputField    field="appealExpensesAmount"                            type="Currency"   inline={ true }       label="Appeal expenses - common property health & safety breaches"                       />
                <InputField    field="legalDefenceAmount"                              type="Currency"   inline={ true }       label="Legal Defence Expenses"                                                           />
                
                <Alert show={ inferred.floodCover == "REQUIRED" } ><p>Flood cover is included with the policy</p></Alert>
                <Alert show={ inferred.floodCover == "NOT_INCLUDED" } ><p>This policy does not included flood cover</p></Alert>
                
                <InputField    field="floodRequested"                                   type="Boolean"                         label="Would you like flood cover"  show={ () => inferred.floodCover == "OPTIONAL"}   />

                <Button.Container>
                    <Button.Back route="/step-2" /> <Button.Save onClick={ this.save.bind(this) }/> <Button.Continue onClick={ this.onContinue.bind(this)} />
                </Button.Container>

            </div>

        )
    }


    onContinue(){
        this.props.actions.validation.validate( this.proceed.bind(this) );
    }


    proceed(){
        this.props.actions.navigation.changeRoute("/step-4")
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/strata/routes/step-3.tsx